import { Outlet } from 'react-router-dom'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { ScrollToTop } from '@/components/ScrollToTop'
import { PushNotificationPermissionBanner } from '@/components/PushNotificationPermissionBanner'

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-bg text-text">
      <ScrollToTop />
      <PushNotificationPermissionBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}